import styled from 'styled-components';

export const SectionWrapper = styled.div`
	margin-bottom: 24px;
`;

export const SectionContent = styled.div``;

export const SectionHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 24px;
`;

export const Title = styled.div`
	color: #1a1a1a;
	font-size: 23px;
	font-weight: 500;
	letter-spacing: 0.3px;
	line-height: 31px;
`;

export const EditLinkWrapper = styled.div``;
